
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'MonorepoSettings',
  props: {
    isMonorepo: {
      type: Boolean,
      required: true
    },
    togglingMonorepoMode: {
      type: Boolean,
      default: false
    }
  }
})
